export function getDateFromTimestamp(timestamp) {
  return new Date(timestamp * 1000)
}
